// @flow

import { h }             from "preact";
import { PureComponent } from "shared-components";
import styles            from "./styles.scss";
import classNames        from "classnames";
import { connect }       from "preact-redux";

import QtyPicker from "../QtyPicker";

import SnaskIcon from "../../icons/snask.svg";
import TicketsIcon from "../../icons/biljetter.svg";

const PRODUCTS = {
  MOVIE_TICKET: 25,
  MENU_TICKET: 1024
};

@connect(
  state    => ({
    items : state.cart.items
  }),
  null,
  ({ items, ...stateProps }, dispatchProps, ownProps) => ({
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    qty: (items.find(x => x.product.id === ownProps.product.id) || {}).qty || 0
  })
)
export default class ProductCard extends PureComponent {
  setQty = qty => this.props.setQty(qty, this.props.product);

  render({ product, qty }: Props, _state: any, { formatPrice, t }: Context) {
    const showQtyPicker = !!this.props.setQty;

    return (
      <div
        class={classNames(
          this.props["class"],
          styles.block
        )}>

        <div
          class={classNames(
            styles.row,
            styles.image_container
          )}>
          <img class={styles.image} src={product.smallImage} />
        </div>

        <div class={styles.header}>
          <div class={styles.row}>
            <div class={styles.column}>
              <h2 class={styles.heading}>
                {product.id === PRODUCTS.MOVIE_TICKET ?
                  <TicketsIcon class={styles.icon} />
                : product.id === PRODUCTS.MENU_TICKET ?
                  <SnaskIcon class={styles.icon} />
                : null}

                <span class={styles.name}>
                  {product.name}
                </span>
              </h2>
            </div>

            <div class={styles.column}>
              {typeof product.msrp === "number" && product.msrp > product.price ?
                <span class={styles.msrp}>
                  {t("PRODUCT.PRICE", {
                    price: formatPrice(product.msrp)
                  })}
                </span>
              : null}

              <span class={styles.price}>
                {t("PRODUCT.PRICE", {
                  price: formatPrice(product.originalPrice)
                })}
              </span>
            </div>
          </div>
        </div>

        {showQtyPicker &&
          <QtyPicker
              name="qty"
              qty={qty}
              setQty={this.setQty}
              max={typeof product.qtyLimit === "number" ? product.qtyLimit : Number.MAX_VALUE}
              min={0}
              class={styles.qty}
          />
        }

        <div
            dangerouslySetInnerHTML={{
              __html: product.description || product.shortDescription
            }}
            class={classNames(
              styles.description,
              "typography",
            )}
        />
      </div>
    );
  }
}
